import React from 'react';
import { Select } from 'antd';

export function VdnVersionSelector({ versions, selectedVersionId, onChangeVersion }) {
  return (
    <section className="releases">
      {versions && !!versions.length && (
        <Select
          allowClear
          placeholder="-- Select VDN version --"
          onChange={onChangeVersion}
          style={{ width: 450 }}
          value={selectedVersionId}
        >
          {versions.map(version => (
            <Select.Option key={version._id} value={version._id}>
              {version.version_name}
              {version.createdAt ? ` (${new Date(version.createdAt).toLocaleString()})` : ''}
            </Select.Option>
          ))}
        </Select>
      )}
    </section>
  );
}
